import React, { useEffect, useState } from 'react';
import { App, Dropdown, MenuProps, Space } from 'antd';
import {
  BookOutlined,
  DownOutlined,
  UserOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { Logo } from '../Logo/Logo';
import { authService } from '../../../../api/authService/authService';
import { authorizationSlice } from '../../../authorization/AuthorizationSlice';
import { defaultData } from '../../../../../index';
import Types, { localStorage } from '../../../../../types/types';

import s from './Header.module.scss';
import { useAppDispatch } from '../../../../core/redux';
import StorageService from '../../../../common/helpers/storageService/storage-service';

const exitItems: MenuProps['items'] = [{ label: 'Выйти', key: 'exit' }];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { setLoading, setIsAuth } = authorizationSlice.actions;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { logOutLink } = Types;
export const Header = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const dispatch = useAppDispatch();
  const { notification } = App.useApp();
  const [open, setOpen] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fetchLogOut, { data, isError, error: tokenError, status, isLoading }] =
    authService.useLogOutMutation();

  const handleMenuClick: MenuProps['onClick'] = () => {
    fetchLogOut('');
    if (process.env?.REACT_APP_OAUTH2 === 'true') {
      setTimeout(() => {
        // dispatch(setIsAuth(false));
        window.open(logOutLink, '_self');
      }, 1000);
    }
    setOpen(false);
  };
  const handleOpenChange = (flag: boolean) => {
    setOpen(flag);
  };

  const showNotification = (message) => {
    notification.info({
      message: message,
      description: 'Не удалось выйти из аккаунта',
      placement: 'topLeft',
      role: 'status',
      icon: <ExclamationCircleOutlined style={{ color: defaultData.errorColor }} />,
    });
  };

  useEffect(() => {
    console.log('data', data);
    if (
      (!isError && status === 'fulfilled' && !isLoading) ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (tokenError?.data?.detail === 'Unauthorized' && !isLoading)
    ) {
      if (process.env?.REACT_APP_OAUTH2 === 'false') {
        StorageService.set(localStorage.token, false);
        dispatch(setIsAuth(false));
      }
      console.log('data', data);
    } else if (isError && tokenError) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      showNotification(tokenError?.data?.detail || tokenError.error);
    }
  }, [isError, tokenError, status, isLoading, data]);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  return (
    <div className={s.Header}>
      <Logo width={'128px'} height={'28px'} />

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ marginRight: '10px' }}>
          <Dropdown
            menu={{
              items: exitItems,
              onClick: handleMenuClick,
            }}
            onOpenChange={handleOpenChange}
            open={open}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <UserOutlined style={{ color: defaultData.colorPrimary }} />
                <DownOutlined style={{ color: defaultData.colorPrimary }} />
              </Space>
            </a>
          </Dropdown>
        </div>

        <BookOutlined />
      </div>
    </div>
  );
};
